<template>
  <div id="chart">
    <v-container class="pt-0">
      <v-layout row wrap>
        <v-flex xs12>
          <p class="resultado text-xs-center">Resultado</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs6 text-xs-right class="switch-label">
          Tablas
        </v-flex>
        <v-flex xs6>
          <v-switch
            label="Gráficas"
            v-model="groupedcharts"
            color="#be3113"
          ></v-switch>
        </v-flex>
        <v-flex xs12 v-if="reports.length == 0">
          <p class="text-xs-center chart-title">
            No existen casos registrados para tu búsqueda.
          </p>
        </v-flex>
        <v-flex xs12 v-if="groupedcharts && reports.length > 0" id="bothcharts">
          <p class="text-xs-center chart-title">
            Homicidios por Identidad de Género y Orientación Sexual de las
            Víctimas{{state && state != 'Todas' ? ' en ' + state : ''}} {{period[0] == period[1] ? period[0] : period[0] + ' - ' + period[1]}}
          </p>
          <v-layout row wrap justify-center>
            <v-flex xs12 sm12 md6 class="chart">
              <p class="text-xs-center chart-subtitle">-Total-</p>
              <StackedBar :labels="labels" :dataset="dataset" />
            </v-flex>
            <v-flex xs12 sm12 md6>
              <p class="text-xs-center chart-subtitle">-Porcentaje-</p>
              <Treemap />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 v-if="!groupedcharts && reports.length > 0">
          <template>
            <v-data-table :headers="headers" :items="reports">
              <template v-slot:items="props">
                <td>{{ props.item.folio }}</td>
                <td class="text-xs-right">{{ props.item.aggressionDate }}</td>
                <td class="text-xs-right">{{ props.item.legalName }}</td>
                <td class="text-xs-right">{{ props.item.chosenName }}</td>
                <td class="text-xs-right">{{ props.item.nationality }}</td>
                <td class="text-xs-right">{{ props.item.age }}</td>
                <td class="text-xs-right">{{ props.item.sexualIdentity }}</td>
              </template>
            </v-data-table>
          </template>
        </v-flex>
        <v-flex xs12 text-xs-right>
          <v-btn outline large color="black" class="btn-black ml-2 mb-3" @click="downloadData()">
            Descargar Datos
          </v-btn>
          <v-btn outline large color="black" class="btn-black ml-2 mb-3" @click="downloadCharts()">
            Descargar SVG
          </v-btn>
        </v-flex>
      </v-layout>
      <hr class="note-line" />
      <p class="note">
        Si cuentas con información sobe el homicidio de una persona LGBT, que no
        se encuentre registrado, puedes hacernos llegar la información al
        siguiente correo: delitosdeodiolgbt@gmail.com
      </p>
      <p class="note italic">
        Esta información puede ser reproducida parcial o totalmente siempre y
        cuando se cite la fuente.
      </p>
    </v-container>
  </div>
</template>

<script>
import StackedBar from "@/components/StackedBar";
import Treemap from "@/components/Treemap";
import * as html2canvas from "html2canvas";
import * as d3 from "d3";
import { type } from 'os';

export default {
  name: "Chart",
  components: {
    StackedBar,
    Treemap
  },
  data() {
    return {
      labels: [],
      dataset: [],
      groupedcharts: true,
      datatable: true,
      headers: [
        {
          value: "case",
          text: "Folio"
        },
        {
          value: "aggressionDate",
          text: "Fecha del hecho"
        },
        {
          value: "legalName",
          text: "Nombre legal"
        },
        {
          value: "chosenName",
          text: "Nombre elegido o asumido"
        },
        {
          value: "nationality",
          text: "Nacionalidad"
        },
        {
          value: "age",
          text: "Edad"
        },
        {
          value: "sexualIdentity",
          text: "Grupo de edad"
        }
      ]
    };
  },
  computed: {
    reports: function() {
      return this.$store.state.filteredReports;
    },
    period: {
      get() {
        return this.$store.state.filters.period;
      }
    },
    state: {
      get() {
        // console.log('get', this.$store.state.filters.state);
        return this.$store.state.filters.state;
      }
    }
  },
  methods: {
    downloadData() {
      let lineArray = [
        "data:text/csv;charset=utf-8,Folio,Fecha del hecho, Nombre legal, Nombre elegido o asumido,Nacionalidad,Edad,Identidad de género/Orientación sexual percibida,Ocupación,Municipio,Entidad,Lugar donde apareció el cuerpo,Característica diferencial,Estado del cuerpo,Arma,¿Hubo indicios de violencia sexual?,¿Hubo indicios de tortura?,¿Hubo detenido?"];
      this.reports.forEach(infoArray => {
        let line = "";
        line += infoArray.folio + ",";
        line += infoArray.aggressionDate + ",";
        line += infoArray.legalName + ",";
        line += infoArray.chosenName + ",";
        line += infoArray.nationality + ",";
        line += infoArray.age + ",";
        line += infoArray.sexualIdentity + ",";
        line += infoArray.occupation + ",";
        line += infoArray.municipality + ",";
        line += infoArray.state + ",";
        line += infoArray.whereWasFound + ",";
        line += infoArray.characteristic + ",";
        line += infoArray.bodyState + ",";
        line += infoArray.weapon + ",";
        line += infoArray.sexualViolence + ",";
        line += infoArray.tortureViolence + ",";
        line += infoArray.wasOffenderFound + ",";
        lineArray.push(line);
      });

      let csvContent = encodeURI(lineArray.join("\n"));
      var link = document.createElement("a");
      link.setAttribute("href", csvContent);
      link.setAttribute("download", "datos-letraese.csv");
      document.body.appendChild(link);
      link.click();
    },
    downloadCharts() {
      const svgBar = document.getElementById("bars");
      const svgTree = document.getElementById("treemap");
      const serializer = new XMLSerializer();
      let sourceBar = serializer.serializeToString(svgBar);
      let sourceTree = serializer.serializeToString(svgTree);
      //add name spaces.
      if (!sourceBar.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
        sourceBar = sourceBar.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
      }
      if (!sourceBar.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
        sourceBar = sourceBar.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
      }
      if (!sourceTree.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
        sourceTree = sourceTree.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
      }
      if (!sourceTree.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
        sourceTree = sourceTree.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
      }
      if (sourceBar.match(/(height="400")/g)) {
        sourceBar = sourceBar.replace(/(height="400")/g, 'height="500"');
        sourceBar = sourceBar.replace('g transform="translate(30,10)"', 'g transform="translate(30,30)"><text text-anchor="middle"  style="font-size: 17px;font-weight: 600; "><tspan x="50%" y="0">HOMICIDIOS POR </tspan><tspan  x="50%" y="17">IDENTIDAD DE GÉNERO Y ORIENTACIÓN SEXUAL </tspan><tspan x="50%" y="34">DE LAS VÍCTIMAS ' + (this.state && this.state != 'Todas' ? 'EN ' + this.state.toUpperCase() + ' ': '') + (this.period[0] < this.period[1] ? this.period[0] + ' - ' + this.period[1] : this.period[0]) + '</tspan><tspan style="font-size: 14px;" x="50%" y="61">Fuente: <tspan fill="#b02020">Letra Ese</tspan></tspan></text></g><g  transform="translate(30,110)"');
      }

      if (sourceTree.match(/(height="400")/g)) {
        sourceTree = sourceTree.replace(/(height="400")/g, 'height="500"');
        sourceTree = sourceTree.replace('g transform="translate(30,10)"', 'g transform="translate(30,30)"><text text-anchor="middle"  style="font-size: 17px;font-weight: 600; "><tspan x="50%" y="0">HOMICIDIOS POR </tspan><tspan  x="50%" y="17">IDENTIDAD DE GÉNERO Y ORIENTACIÓN SEXUAL </tspan><tspan x="50%" y="34">DE LAS VÍCTIMAS ' + (this.state && this.state != 'Todas' ? 'EN ' + this.state.toUpperCase() + ' ': '') + (this.period[0] < this.period[1] ? this.period[0] + ' - ' + this.period[1] : this.period[0]) + '</tspan><tspan style="font-size: 14px;" x="50%" y="61">Fuente: <tspan fill="#b02020">Letra Ese</tspan></tspan></text></g><g  transform="translate(30,110)"');
      }

      //add xml declaration
      sourceBar = '<?xml version="1.0" standalone="no"?>\r\n' + sourceBar;
      sourceTree = '<?xml version="1.0" standalone="no"?>\r\n' + sourceTree;

      //convert svg source to URI data scheme.
      const urlBar = "data:image/svg+xml;charset=utf-8,"+encodeURIComponent(sourceBar);
      const urlTree = "data:image/svg+xml;charset=utf-8,"+encodeURIComponent(sourceTree);

      const linkBar = document.createElement("a");
      linkBar.setAttribute("href", urlBar);
      linkBar.setAttribute("download", "letraese-bars.svg");
      document.body.appendChild(linkBar);
      linkBar.click();

      const linkTree = document.createElement("a");
      linkTree.setAttribute("href", urlTree);
      linkTree.setAttribute("download", "letraese-tree.svg");
      document.body.appendChild(linkTree);
      linkTree.click();
    }
  }
};
</script>

<style scoped>
#chart {
  font-family: "Open Sans", sans-serif;
  background-color: #fff;
}

#chart .resultado {
  background-color: black;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  width: 25%;
}

.chart-title {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 15px;
}

.chart-subtitle {
  text-transform: uppercase;
}

.btn-black {
  border-radius: 10px;
  font-weight: 600;
  border: 2px solid black !important;
  font-size: 12px;
  margin-top: 8%;
}

.v-input >>> .v-label {
  font-weight: 700 !important;
  font-size: 14px;
  color: black;
}

.switch-label {
  font-weight: 700 !important;
  font-size: 14px;
  padding-right: 10px;
  padding-bottom: 5px;
}
</style>
